import api from "../BrandOnBoarding/api";

export async function fetchCategoryMonitoringGroups(customerId, includeInactive = false) {
  const params = new URLSearchParams({ customer_id: customerId });
  if (includeInactive) params.set("include_inactive", "true");
  const res = await api.get(`/category-monitoring/onboarding?${params.toString()}`);
  return res.data?.data || [];
}

export async function fetchVisibilityPromptTemplates(customerId) {
  const res = await api.get(`/category-monitoring/onboarding/templates?customer_id=${customerId}`);
  return res.data?.data || [];
}

export async function createCategoryMonitoringGroup(payload) {
  const res = await api.post("/category-monitoring/onboarding", payload);
  return res.data?.data;
}

export async function updateCategoryMonitoringGroup(payload) {
  const res = await api.put("/category-monitoring/onboarding", payload);
  return res.data?.data;
}

export async function deleteCategoryMonitoringGroup(payload) {
  const res = await api.delete("/category-monitoring/onboarding", { data: payload });
  return res.data;
}
